import { isNullOrUndefined } from 'utils/util';

export function removeAttrInMetaTags(attr: string): void {
  document.head.querySelectorAll('meta').forEach((meta) => {
    if (!isNullOrUndefined(meta.getAttribute(attr))) {
      meta.removeAttribute(attr);
    }
  });
}
